export default "__VITE_ASSET__BIUR9dqV__"